import * as React from "react";
import { ActiveCell, SignatureCell } from "../GridComponents";
import EditActivityTag from "./EditActivityTag";
import List from "components/Setting/List";
import { updateActivityTag, useActivityTag } from "services/activityTagService";

const RowColorCell = (props) => {
  const { dataItem } = props;
  const colour = dataItem.colour;
  const hasColor = colour && colour !== "none" && colour.trim() !== "";

  return (
    <td className="text-center align-middle">
      {hasColor ? (
        <div
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: colour,
            border: "1px solid #ccc",
            borderRadius: "3px",
            margin: "0 auto",
          }}
        />
      ) : (
        <div
          style={{
            width: "18px",
            height: "18px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "3px",
            position: "relative",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "22px",
              height: "2px",
              background: "#f8c2c2",
              transform: "translate(-50%, -50%) rotate(45deg)",
              borderRadius: "1px",
            }}
          />
        </div>
      )}
    </td>
  );
};

const ActivityTagsList = () => {
  const { data: gridData, loading } = useActivityTag();

  return (
    <List
      editAction={updateActivityTag}
      editFormComponent={EditActivityTag}
      component="activityTags"
      columns={[
        { field: "name", title: " ", cell: SignatureCell, width: "80" },
        { field: "name", title: "Name" },
        {
          cell: RowColorCell,
          title: "Row Color",
          field: "colour",
          width: "100",
          headerClassName: "grid-header-center",
        },
        { cell: ActiveCell, title: "Active", field: "active", width: "80", headerClassName: "grid-header-center", },
      ]}
      gridData={gridData}
      loading={loading}
    />
  );
};

export default ActivityTagsList;
